<template>
    <div>
        <p class="description" style="text-align: left; line-height: 1.2">
            This feature is not available on the free plan. <a href="account/change-plan" style="text-decoration: underline; color: inherit;">Upgrade</a> to unlock unlimited features.
        </p>
        <v-btn @click="upgradePlan" dark class="modal-btn --primary mx-auto d-block mt-5">Upgrade plan</v-btn>
    </div>
</template>

<script>
export default {
    methods: {
        upgradePlan() {
            this.$router.push({ name: 'account.billing.changePlan' });
        }
    }
};
</script>